/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const OverView = ({
  loadWeb3,
  account,
  tokenBalance,
  unClaimedBalance,
  claim,
  nftBalance,
  tokensPerNft,
}) => {
  const claimHandler = () => {
    if (account) {
      claim();
    } else {
      loadWeb3();
    }
  };

  const btnClasses =
    "mt-6 py-1.5 px-4 rounded-sm text-white font-bold text-xl uppercase ";
  return (
    <section>
      <div className="container">
        <div className="bg-primary-400  bg-opacity-10 p-8 py-12 mt-10   mb-20">
          <h1 className="text-5xl uppercase font-bold text-center ">
            Overview
          </h1>
          {!account || nftBalance <= 0 ? (
            <p className="text-center mt-4 text-xl capitalize  mx-auto">
              You Have {nftBalance} NFTs worth{" "}
              <span className="text-red-500">
                {tokensPerNft} CHADX {""}
              </span>{" "}
              token each, Currently Your Balance Is {unClaimedBalance} CHADX
              Token,
              <br /> Do You Wish To Withdraw Or Leave?
            </p>
          ) : (
            <p className="text-center mt-4 text-xl capitalize  mx-auto">
              You Have {nftBalance} NFTs Worth{" "}
              <span className="text-red-500">{tokensPerNft} CHADX &nbsp;</span>
              Token Each (currently) , Your Balance Is {unClaimedBalance} CHADX
              Token, You Can Withdraw Your Current Claim Or Leave Your UnClaimed
              Token And View Your Balance Below.
            </p>
          )}
          <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-2">
            <div className="text-center">
              <h3 className="text-2xl font-bold">YOUR CHADX BALANCE</h3>
              <br />
              <p className="text-lg">
                CHADX <span>{Number(tokenBalance).toFixed(2)}</span>
              </p>
              <a
                href="https://app.uniswap.org/#/swap?inputCurrency=0xcaaeea96a42dda1c2045f198fedf298ed5adb039&chain=mainnet"
                target={"_blank"}
                className={`block  max-w-max mx-auto bg-primary-400 ${btnClasses}`}
                rel="noreferrer"
              >
                {"BUY CHADX TOKEN NOW"}
              </a>
              <a
                href="https://chadnft.online/mint/"
                target={"_blank"}
                className={`inline-block  bg-primary-400 ${btnClasses}`}
                rel="noreferrer"
              >
                {"BUY C&B NFT"}
              </a>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold">YOUR UNCLAIMED REWARDS</h3>
              <br />
              <p className="text-lg">
                CHADX &nbsp; <span>{unClaimedBalance}</span>
              </p>
              <button
                className={`${
                  unClaimedBalance <= 0
                    ? " pointer-events-none bg-gray-500"
                    : "bg-primary-400"
                } ${btnClasses}`}
                onClick={claimHandler}
              >
                {account ? "Claim" : "Connect Wallet"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverView;
